module.exports = __webpack_public_path__ + "static/media/24UHCHR1.41d13cb1.jpg";